export default __webpack_public_path__ + "static/media/painting_frame.a4ce3890.png";